import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { IllustrationImage } from '@/common/components/Illustrations/IllustrationImage';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { Translate } from '@/common/components/Translate/Translate';
import { TMealPaymentStrategy } from '@/common/integrations/menhir/employee/meal/meal.types';

export const ITMealPaymentStrategyLearningCenter = ({
  type,
  onClose,
}: TITMealPaymentStrategyLearningCenterProps) => {
  const { t } = useTranslation();

  return (
    <ModalLearning.Root onClose={onClose} heightClass="h-[50rem]">
      {type !== 'credits' ? (
        <ModalLearning.Step
          title={t(
            'dashboard.it.meal.payment_strategy.page.learning_center.automatic.title'
          )}
          description={
            <Translate
              parent={BodyText}
              i18nKey="dashboard.it.meal.payment_strategy.page.learning_center.automatic.description"
            />
          }
          asset={
            <IllustrationImage
              source={require('@/assets/illustrations/illustration-buoni-pasto-card-linked.png')}
              transition={250}
            />
          }
        />
      ) : null}
      {type !== 'card' ? (
        <ModalLearning.Step
          title={t(
            'dashboard.it.meal.payment_strategy.page.learning_center.manual.title'
          )}
          description={
            <Translate
              parent={BodyText}
              i18nKey="dashboard.it.meal.payment_strategy.page.learning_center.manual.description"
            />
          }
          asset={
            <IllustrationImage
              source={require('@/assets/illustrations/illustration-buoni-pasto-credits.png')}
              transition={250}
            />
          }
        />
      ) : null}
    </ModalLearning.Root>
  );
};

export type TITMealPaymentStrategyLearningCenterProps = {
  type: TMealPaymentStrategy;
  onClose: () => void;
};
